module.exports = __webpack_public_path__ + "static/media/icon_info_blue.a2ee2f8c.svg";